
import Vue from "vue"
import galleryMixin from "@/mixins/gallery"

export default Vue.extend({
  mixins: [galleryMixin],
})
